const right_set = {
  namespaced: true,
  state: {
    dialogVisible: false,
    active: 'set'
  },
  mutations: {
    set_dialog(state, dialogVisible) {
      state.dialogVisible = dialogVisible
    },
    set_active(state, active) {
      state.active = active
    }
  },
  actions: {}
}


export default right_set



// WEBPACK FOOTER //
// ./src/vuex/modules/right_set.js